import { useEffect } from "react";
import { Button } from "flowbite-react";
import errr from "../../assets/images/CustomersPartners/errr.webp";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function Error404() {
  const navigate = useNavigate();
  useEffect(() => {
    const hasError = true;
    if (hasError) {
      navigate("/404");
    }
  }, [navigate]);
  return (
    <div className="w-full flex flex-col pt-32 container mx-auto py-[30px] px-[90px] items-center justify-center gap-3">
      <div>
        <img src={errr} alt="er" />
      </div>
      <div>
        <p className="text-[16px] font-normal text-[#053CC8]">
          Rất tiếc! Trang bạn đang tìm kiếm hiện không tồn tại
        </p>
      </div>
      <div className="text-[16px] text-[#333333] font-normal">
        <p>
          Nếu bạn cần hỗ trợ, vui lòng liên hệ hotline:{" "}
          <span className="text-[#033F6A]">0981.317.225</span> hoặc
          <span className="text-[#033F6A]"> support@bluerise.com.vn</span>
        </p>
      </div>
      <div>
        <Link to="/">
          <Button className="bg-blue-700 text-white hover:bg-blue-800 rounded-[40px]">
            <p>Quay lại trang chủ</p>
          </Button>
        </Link>
      </div>
    </div>
  );
}
